// extracted by mini-css-extract-plugin
export default {"medium":"992px","App":"App_App__KTTz5"};